import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UmpireArticle} from '@tisa-group/models';
import {UmpireComponentClientComponent} from '@tisa-group/client-ui/components/umpire-component-client';

@Component({
  selector: 'tisa-article',
  imports: [CommonModule, UmpireComponentClientComponent],
  templateUrl: './article.component.html',
  styleUrl: './article.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticleComponent {
  article = input<UmpireArticle | null>();

  sortedComponents = computed(() => {
    if (!this.article()?.components) {
      return [];
    }
    return [...this.article()!.components].sort(
      (a, b) => (a?.index ?? 0) - (b?.index ?? 0),
    );
  });
}
